import React, { useContext } from 'react';
import { bool, func } from 'prop-types';
import * as R from 'ramda';

// Components
import { Box } from '@mui/material';
import ProductCheckboxList from '../../components/ProductCheckboxList.connector';
import Buttons from '../../components/Buttons';

// Context
import { SequencingWizardContext } from '../../SequencingWizardContext';

const LastStep2 = ({ loading, prev, next }) => {
  const {
    data: { inventoryOwners = [], products = [] },
    setData,
  } = useContext(SequencingWizardContext);
  const continueDisabled = R.isEmpty(products);
  const handleProducts = R.o(setData, R.assoc('products'));
  const lastInventoryOwner = `${
    inventoryOwners[inventoryOwners.length - 1]?.companyCustomerIdName
  } ${inventoryOwners[inventoryOwners.length - 1]?.nameLong}`;

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          // height of other components is 157px
          // prevents progress bar from looking off
          height: 'calc(100% - 157px)',
          overflowY: 'auto',
        }}
      >
        <Box flexGrow={1}>
          <ProductCheckboxList
            inventoryOwners={inventoryOwners}
            onChange={handleProducts}
            title={`Select one or more ${lastInventoryOwner} products`}
          />
        </Box>
      </Box>
      <Buttons
        disabled={continueDisabled}
        handleLeftButtonClick={prev}
        handleRightButtonClick={next}
        leftLabel="Back"
        loadingData={loading}
        rightLabel="Continue"
      />
    </>
  );
};

LastStep2.propTypes = {
  loading: bool.isRequired,
  next: func.isRequired,
  prev: func.isRequired,
};

export default LastStep2;
